import { createSlice, PayloadAction } from '@reduxjs/toolkit';

const initialState = {
  drugSupplyRowData: {},
  confirmSupplyData: {},
  shippedData: {},
  depotsData: [],
  openResupplyOrderPage: false,
  newResupplyorder: false,
  selectedResupply: {}
};

export const drugSupplySlice = createSlice({
  name: 'drugSupplySlice',
  initialState,
  reducers: {
    clearDrugSuppluRowData: state => {
      state.drugSupplyRowData = {};
    },
    setDrugSupplyRowData: (state, action: PayloadAction<any>) => {
      state.drugSupplyRowData = action.payload;
    },
    setDepotsReduxData: (state, action: PayloadAction<any>) => {
      state.depotsData = action.payload;
    },
    setConfirmSupplyData: (state, action: PayloadAction<any>) => {
      state.confirmSupplyData = action.payload;
    },
    setShippedData: (state, action: PayloadAction<any>) => {
      state.shippedData = action.payload;
    },
    setOpenResupplyOrderPage: (state, action: PayloadAction<any>) => {
      state.openResupplyOrderPage = action.payload;
    },
    setNewResupplyOrder: (state, action: PayloadAction<any>) => {
      state.newResupplyorder = action.payload;
    },
    setSelectedResupply: (state, action: PayloadAction<any>) => {
      state.selectedResupply = action.payload;
    }
  }
});

export const {
  clearDrugSuppluRowData,
  setDrugSupplyRowData,
  setDepotsReduxData,
  setConfirmSupplyData,
  setShippedData,
  setOpenResupplyOrderPage,
  setNewResupplyOrder,
  setSelectedResupply
} = drugSupplySlice.actions;
